module.exports = __webpack_public_path__ + "img/logo.52d9fd00.png";